import { render, staticRenderFns } from "./SchoolManage.vue?vue&type=template&id=adbc1468&scoped=true"
import script from "./SchoolManage.vue?vue&type=script&lang=js"
export * from "./SchoolManage.vue?vue&type=script&lang=js"
import style0 from "./SchoolManage.vue?vue&type=style&index=0&id=adbc1468&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adbc1468",
  null
  
)

export default component.exports